var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navtab__main-container",class:{ active: _vm.$route.path.includes(_vm.to)},on:{"click":function($event){return _vm.onNavClick(_vm.to)}}},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.showBadge)?_c('b-badge',{staticClass:"ml-2 custom-badge",attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.count))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }